// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3fj7f","textarea":"styles_textarea__1c1yE"};